<template>
  <!-- eslint-disable vue/no-v-model-argument -->
  <div>
    <fieldset>
      <legend>
        {{ $t('Select your business entity type') }}
      </legend>

      <NlBusinessEntityTypeRadioGroup v-model="businessEntityType" name="business_entity" />
    </fieldset>
    <br>
    <fieldset v-if="hasSelectedValidBusinessEntityType">
      <legend>
        {{ $t('Add your business details') }}
      </legend>

      <NlBusinessEntityDetailsForm
        v-model:business-entity="internalBusinessEntity"
        :compliance-data="complianceData"
      />
    </fieldset>

    <SubmitButton :text="$t('Save')" auto-submit class="m-t-20" />
  </div>
</template>

<script>
import { computed, ref } from 'vue'
import SubmitButton from '@/components/SubmitButton.vue'
import NlBusinessEntityDetailsForm from '@/components/compliances/BusinessEntity/Nl/NlBusinessEntityDetailsForm.vue'
import NlBusinessEntityTypeRadioGroup from '@/components/compliances/BusinessEntity/Nl/NlBusinessEntityTypeRadioGroup.vue'

export default {
  name: 'FreelancerNlBusinessEntityForm',

  components: {
    NlBusinessEntityDetailsForm,
    NlBusinessEntityTypeRadioGroup,
    SubmitButton,
  },

  props: {
    businessEntity: {
      type: Object,
      required: true,
    },

    complianceData: {
      type: Object,
      required: true,
    },

    freelancer: {
      type: Object,
      required: true,
    },
  },

  emits: ['update:businessEntity'],

  setup(props, { emit }) {
    const internalBusinessEntity = ref(props.businessEntity)

    const businessEntityType = computed({
      get() {
        return internalBusinessEntity.value.entityType
      },

      set(value) {
        internalBusinessEntity.value.entityType = value
        emit('update:businessEntity', internalBusinessEntity.value)
      },
    })

    const hasSelectedValidBusinessEntityType = computed(() =>
      ['nl_limited', 'nl_sole_trader', 'nl_general_partnership', 'nl_professional_partnership'].includes(businessEntityType.value),
    )

    return {
      businessEntityType,
      hasSelectedValidBusinessEntityType,
      internalBusinessEntity,
    }
  },
}
</script>

